export const WEB_SERVICE = "https://rgsweb.eodyne.com/rgsmims/backend/dashboard/src";
export const primaryColor = "#26A9B6";
export const gray = "#CCC";
export const borderColor = "#808080";
export const green = "#39B54A";
export const red = "#FF3333";
